import { Base } from '../Base';
import { Default } from '@master/annotation/Default';
export class TenantSettings extends Base {
  @Default(null)
  pky?: number;
  
  @Default(null)
  oid?: string;
  
  @Default(null)
  ctm?: number; // created timestamp (Unix time in ms)
  
  @Default(null)
  utm?: number; // updated timestamp (Unix time in ms)
  
  @Default(true)
  tenantMandateCPFInflowInput?: boolean = true;
  
  @Default(true)
  tenantMandateRiskProfile?: boolean = true;
  
  @Default(true)
  tenantValidateDeathNeed?: boolean = true;
  
  @Default(true)
  tenantValidateCINeed?: boolean = true;

  @Default(true)
  tenantValidateDisabilityNeed?: boolean = true;
  
  @Default(true)
  tenantValidateRetirementNeed?: boolean = true;
  
  @Default(true)
  tenantValidateChildrenEduNeed?: boolean = true;
  
  @Default(80)
  tenantUnderUtilizedBudgetPercentage?: number = 80;
  
  @Default('MISMATCH')
  tenantValidatePortfolioCltRiskProfile?: 'MISMATCH' | string = 'MISMATCH'; // consider using a union if there are more known values
  
}
